import { DashboardPopUpFactory, DashboardPopUpType } from '../../genericDashboard/utils/dashboard.pop-up.factory';
import { WebComponentEvent } from '../../framework/BaseWebComponentController';
import { ConsoleRequest, DataProviderType } from '../request';
import { GzToast, ToastSeverity } from '../../ui/gzToastNotification/type';
import { GzToastNotificationWebComponent } from '../../ui/gzToastNotification';
import { translateFn } from '../translator.helper';
import { RegexValidator } from '../../ui/gzForm/validators/regex.validator';
import { MaxLengthValidator } from '../../ui/gzForm/validators/max-length.validator';
import { isEmpty } from 'lodash';

export class FeedbackHelper {
  public static async createFeedbackElement(
    betaType: number,
    popupType = DashboardPopUpType.FEEDBACK_VIEW_DIALOG,
    hasExtraInfo = false,
    parentElement: HTMLElement | null = null
  ) {
    DashboardPopUpFactory.createPopUp(
      popupType,
      async (ev: WebComponentEvent): Promise<void> => {
        await FeedbackHelper.handleConfirmButtonClicked(betaType, ev.detail.feedback);
      },
      (): void => {},
      {
        validators: [
          RegexValidator(
            RegExp('^[a-zA-Z0-9,.;?!"`\':\\s\\r\\n-]+$'),
            translateFn('Your feedback contains unsupported characters.')
          ),
          MaxLengthValidator(500, translateFn('You have reached the maximum number of 500 characters.')),
        ],
        hasExtraInfo: hasExtraInfo,
        parentElement: parentElement,
        feedbackType: betaType,
      }
    );
  }

  public static async handleConfirmButtonClicked(betaType: number, feedbackData: any) {
    try {
      const type = isEmpty(feedbackData.type) ? betaType : Number(feedbackData.type);
      delete feedbackData.type;

      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'BetaPrograms',
        method: 'sendFeedbackEmail',
        payload: {
          type: type,
          feedback: feedbackData,
        },
      });

      if (!response.success) {
        FeedbackHelper.showFeedbackError();
      } else {
        FeedbackHelper.showFeedbackSuccess();
      }
    } catch (e) {
      FeedbackHelper.showFeedbackError();
    }
  }

  public static showFeedbackError() {
    const toastNotificationConfigs: GzToast = {
      message: translateFn('Failed to submit feedback'),
      hasAction: false,
      severity: ToastSeverity.ERROR,
    };
    GzToastNotificationWebComponent.buildToastWrapperElement(toastNotificationConfigs);
  }

  public static showFeedbackSuccess() {
    const toastNotificationConfigs: GzToast = {
      message: translateFn('Thank you for being a part of our journey!'),
      hasAction: false,
      severity: ToastSeverity.SUCCESS,
    };
    GzToastNotificationWebComponent.buildToastWrapperElement(toastNotificationConfigs);
  }

  public static trimFeedbackData<T extends object>(feedbackInfo: T, feedbackKeyToFormMap: Map<string, string>): T {
    for (const key of Object.keys(feedbackInfo)) {
      const value = feedbackKeyToFormMap.get(key) as string;
      if (value && value !== '') {
        feedbackInfo[key] = value;
      } else {
        delete feedbackInfo[key];
      }
    }

    return feedbackInfo;
  }
}
